import { useState, useEffect } from 'react'
import { Observable, Property } from 'baconjs'

export function useObservable<E, V>(
  observable: Observable<E, V> | Property<E, V>,
  initValue: V | null = null
): [V | null, E | null] {
  const [value, setValue] = useState<null | V>(initValue)
  const [error, setError] = useState<null | E>(null)

  useEffect(() => {
    const subs = [observable.onValue(setValue), observable.onError((err) => setError(err))]
    return () => {
      subs.map((fn) => fn())
    }
  }, [])

  return [value, error]
}
